import React, { useEffect, useState } from "react"
import Navbar from "../../components/admin/Navbar.tsx";
import Messaging from "../../components/admin/messaging/Menssaging.tsx";
import InboxMessaging from "../../components/admin/messaging/InboxMessaging.tsx";
import SentMessaging from "../../components/admin/messaging/SentMessaging.tsx";
import ComposeMessaging from "../../components/admin/messaging/ComposeMessaging.tsx";

/**
 * Represents the home page of the application.
 * It includes a navigation bar, a navigation section, sports schedule, and a schedule table.
 * @returns JSX elements representing the home page layout.
 */
export const LayoutMessagingAdmin = () => {
    const [view, setView] = useState('inbox');

    useEffect(() => {
        document.body.classList.add("admin-body");
        return () => {
            document.body.classList.remove("admin-body");
        };
    }, []);

    const renderView = () => {
        switch (view) {
            case 'inbox':
                return <InboxMessaging />;
            case 'sent':
                return <SentMessaging />;
            case 'compose':
                return <ComposeMessaging />;
            default:
                return <InboxMessaging />;
        }
    };

    return (
        <>
            <Navbar />
            <div className="container-fluid admin-shell">
                <div className="row">
                    <div className="col-lg-3 col-xs-12">
                        <Messaging onViewChange={setView} activeView={view} />
                    </div>
                    <div className="col-lg-9 col-xs-12">
                        {renderView()}
                    </div>
                </div>
            </div>
        </>
    );
}
